import { createContext } from 'react'

const ServerSideContext = createContext(true)

export default ServerSideContext
